import { Component, Input, OnChanges } from '@angular/core';

import { GoPaperlessModel } from '../shared';

@Component({
  selector: 'app-go-paperless-policy-list',
  templateUrl: './go-paperless-policy-list.component.html',
  styleUrls: ['./go-paperless-policy-list.component.scss'],
  standalone: false
})
export class GoPaperlessPolicyListComponent implements OnChanges {
  @Input() models = new Array<GoPaperlessModel>();

  modelPairs = new Array<Array<GoPaperlessModel>>();

  constructor() {}

  ngOnChanges() {
    this.modelPairs = this.models.reduce((result, model, index) => {
      if (index % 2 === 0) {
        result.push([model]);
      } else {
        result[result.length - 1].push(model);
      }

      return result;
    }, new Array<Array<GoPaperlessModel>>());
  }
}
